import dayjs from 'dayjs';

export function formatDuration(duration: number | null) {
  if (!duration) {
    return '';
  }

  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);

  if (hours > 0) {
    return dayjs.duration(duration, 'seconds').format('H[h] m[m] s[s]');
  }
  if (minutes > 0) {
    return dayjs.duration(duration, 'seconds').format('m[m] s[s]');
  }
  return dayjs.duration(duration, 'seconds').format('s[s]');
}
